<template>
  <div class="help-answer">
    <van-nav-bar title="在线帮助" @click-left="reBack" left-arrow :class="{'isiOSX':isiOSX}"/>
    <div class="moreProblem" v-for="item in list" v-if="isList == 1">
      <div class="title">{{item.title}}</div>
      <div class="contetn" v-html="item.content"></div>
    </div>
    <div class="moreProblem" v-if="isList == 2">
      <div class="title">{{anwser.title}}</div>
      <div class="contetn" v-html="anwser.content"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      list: [],
      anwser: {},
	    isiOSX: false,
	    isList: 0,//1列表页问题，2一二级问题展示
    };
  },
  created(){
		this.isiOSX = this.isIphoneX();
　　	this.getInfo();
	},
  methods: {
  	getInfo() {
  		if(this.$route.query.isList == 1) {
  			this.$api.post("/cms/member/help/get/list", {id:this.$route.query.id}).then(res => {
		        this.list = res.list;
		        this.isList = 1;
		    });
  		}else {
  			this.$api.get("/cms/member/help/detail", {id:this.$route.query.id}).then(res => {
	        	this.anwser = res;
		        this.isList = 2;
	    	});
  		}
    },
    reBack(){
      this.$router.go(-1);
    },
  }
};
</script>
<style lang='less' scoped>
.help-answer {
  background-color: #f2f2f2;
  height: 100%;
  .van-nav-bar {
    background: #f2f2f2;
    padding-top: 24px;
    position: relative;
    .van-nav-bar__title {
      font-size: 18px;
      color: #333;
    }
    .van-icon-arrow-left:before {
      display: none;
    }
    .van-nav-bar__left {
      left: 11px;
      .van-icon {
        width: 17px;
        height: 15px;
        display: inline-block;
        background: url(../../assets/plane/reBack.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }
  .isiOSX {
		padding-top: 44px;
	}
  .moreProblem {
    background: #fff;
    width: 100%;
    margin: 0 auto;
    padding: 0 12px 12px;
    box-sizing: border-box;
    overflow: hidden;
    border-bottom: solid 7px #f2f2f2;
    div {
      font-size: 12px;
      color: #333333;
    }
    .title {
    	/*height: 41px;*/
      line-height: 25px;
      font-size: 14px;
      color: #333;
      font-weight: bold;
      padding: 15px 0 7px 0;
    }
    .content {
    	line-height: 22px;
      font-size: 13px;
      color: #333;
    }
  }
}


</style>



